module.exports = __webpack_public_path__ + "img/covid5.3298cfc8.jpg";